import { Component, Vue } from "vue-property-decorator";
import { BuffetCategories } from "@/helpers/constants";
import { BuffetCategory } from "@/services/apiService/api.types";
import apiStorageInterface, {
  sortedBuffetCategories
} from "@/services/apiStorageInterface";
import dayjs from "dayjs";

@Component
export class BuffetCategoriesFilter extends Vue {
  //@TODO implement mixin everywhere it is needed
  buffetCategories: Record<BuffetCategories, BuffetCategory> =
    sortedBuffetCategories;
  filteredBuffetCategories: BuffetCategories[] = [];
  buffetActiveDate = "";

  async setCategories(date?: string): Promise<void> {
    if (!dayjs(this.buffetActiveDate).isSame(dayjs(date, "day"))) {
      this.buffetCategories =
        await apiStorageInterface.fetchSortedBuffetCategories(
          date ? date : dayjs().format("YYYY-MM-DD")
        );
      this.buffetActiveDate = date ? date : dayjs().format("YYYY-MM-DD");
    }
  }

  filteredCategoriesFunc(): void {
    if (this.buffetCategories) {
      this.filteredBuffetCategories = [];
      Object.entries(this.buffetCategories).forEach(([key, value]) => {
        if (
          (value.epgList && value.epgList.length > 0) ||
          key === BuffetCategories.Home
        ) {
          this.filteredBuffetCategories.push(key as BuffetCategories);
        }
      });
    }
  }
}
